import { CheckCircle2, AlertTriangle } from 'lucide-react';
import Button from "../../../../components/Button";
// Remove the import line for fridgeImg since we're using public folder path
import styles from "../css/ecoControlFridges.module.css";

export default function FridgeGrid({ fridges, visibleFridges, onDetailsClick, onContentsClick }) {
  return (
    <div className={styles.fridgeGrid}>
      {visibleFridges.map((f) => (
        <div key={f.bin} className={styles.fridgeCard}>
          <img src="/images/SmartFridge.jpg" alt={f.name} className={styles.fridgeImage} />
          <div className={styles.fridgeMeta}>
            <div className={styles.fridgeBin}>{f.bin}</div>
            <div className={styles.fridgeName}>{f.name}</div>
            <div className={styles.fridgeTemp}>{f.temp}</div>
            <div className={styles.fridgeStatus}>
            {f.status === 'ok' ? (
              <CheckCircle2 size={22} strokeWidth={3} color="#16a34a" />
              ) : (
              <AlertTriangle size={22} strokeWidth={3} color="#ef4444" />
            )}
          </div>
          </div>
          <div className={styles.fridgeButtons}>
            <Button variant="primary" onClick={() => onDetailsClick(f)}>Details</Button>
            <Button variant="primary" onClick={() => onContentsClick(f)}>Contents</Button>
          </div>
        </div>
      ))}
    </div>
  );
}

